<template>
  <div>
    <el-dialog
      :title="'Chuyển sang nghỉ làm: ' + fullName"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      custom-class="sk-dialog"
      top="20vh"
    >
      <div class="sk-dialog-content">
        <div class="sk-panel">
          <div class="sk-panel-head">
            <div class="sk-panel-icon"><i class="el-icon-date"></i></div>
            <div>
              <p class="sk-panel-title">Xác nhận nghỉ làm</p>
              <p class="sk-panel-subtitle">Chọn ngày nghỉ làm chính thức cho nhân viên.</p>
            </div>
          </div>
          <el-form :model="dataInput" ref="dataInput" label-width="150px">
            <el-form-item label="Chọn ngày nghỉ làm" prop="date">
              <el-date-picker
                v-model="dataInput.date"
                type="date"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                placeholder="Chọn ngày"
                :clearable="false"
              ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="sk-dialog-footer">
        <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialog()">
          <i class="el-icon-circle-close" />
          <span>{{ $t("button.close") }}</span>
        </el-button>
        <el-button
          class="btn-save"
          type="success"
          size="medium"
          :loading="loadingButton"
          @click="submitForm()"
        >
          <i class="el-icon-circle-check" />
          <span>{{ $t("button.save") }}</span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import EmployeeDataService from "@/services/EmployeeService/EmployeeDataService";
export default {
  props: {
    dialogVisible: null,
  },
  data() {
    return {
      fullName: "",
      dataInput: { date: "" },
      loadingButton: false,
    };
  },
  methods: {
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
        this.responseList = [];
      }, 300);
    },
    submitForm() {
      this.loadingButton = true;
      EmployeeDataService.updateEmployeeStatus(this.dataInput)
        .then((resp) => {
          this.$message({
            message: resp.data.message,
            type: "success",
          });
          setTimeout(() => {
            this.closeDialog();
          }, 500);
        })
        .catch((err) => {
          this.$message({
            message: err.response.data.message,
            type: "error",
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.loadingButton = false;
          }, 500);
        });
    },
    getStatusDataInitial(id, fullName) {
      this.dataInput.date = moment(String(new Date())).format("YYYY-MM-DD");
      this.fullName = fullName;
      this.dataInput.id = id;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
</style>
